import React from 'react';
import { getCategoriesSorted, getSubcategories } from '../../data/categories';
import { CONDITIONS } from '../../data/categories';
import PriceRangeFilter from './PriceRangeFilter';
import RecentSearches from './RecentSearches';
import './FilterSidebar.css';

function FilterSidebar({ filters, onChange }) {
  const categoriesList = getCategoriesSorted();
  const subcategoriesList = getSubcategories(filters.category);

  return (
    <div className="filterSidebar">
      <RecentSearches />
      <h3 className="filterSidebarTitle">Filters</h3>

      {/* Category */}
      <div className="filterGroup">
        <label>Category</label>
        <select
          value={filters.category || ''}
          onChange={(e) =>
            onChange({ ...filters, category: e.target.value, subcategory: '' })
          }
          className="filterSelect"
        >
          <option value="">All</option>
          {categoriesList.map((cat) => (
            <option key={cat.id} value={cat.name}>
              {cat.name}
            </option>
          ))}
        </select>
      </div>

      {/* Subcategory */}
      {subcategoriesList.length > 0 && (
        <div className="filterGroup">
          <label>Subcategory</label>
          <select
            value={filters.subcategory || ''}
            onChange={(e) =>
              onChange({ ...filters, subcategory: e.target.value })
            }
            className="filterSelect"
          >
            <option value="">All</option>
            {subcategoriesList.map((sub) => (
              <option key={sub} value={sub}>
                {sub}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Price Range */}
      <PriceRangeFilter
        minPrice={filters.minPrice}
        maxPrice={filters.maxPrice}
        onChange={(minPrice, maxPrice) =>
          onChange({ ...filters, minPrice, maxPrice })
        }
      />

      {/* Condition */}
      <div className="filterGroup">
        <label>Condition</label>
        <select
          value={filters.condition || ''}
          onChange={(e) => onChange({ ...filters, condition: e.target.value })}
          className="filterSelect"
        >
          <option value="">All</option>
          {CONDITIONS.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>

      {/* Ad type section removed from here */}

      {/* Feature Flags */}
      <div className="filterGroup">

      </div>

      <div className="filterGroup">

      </div>

      <div className="filterGroup">

      </div>

      {/* Date Posted */}
      <div className="filterGroup">
        <label>Date posted</label>
        <select
          value={filters.datePosted || ''}
          onChange={(e) => onChange({ ...filters, datePosted: e.target.value })}
          className="filterSelect"
        >
          <option value="">Any time</option>
          <option value="today">Today</option>
          <option value="7">Last 7 days</option>
          <option value="30">Last 30 days</option>
        </select>
      </div>
    </div>
  );
}

export default FilterSidebar;
